import * as Sentry from '@sentry/browser';

export const logFetchErrorToSentry = ({ error, url }: { error: unknown; url: string }) => {
  Sentry.captureException(new Error(`${error} - ${url}`));
};
